import React, { Component } from 'react';
import { getIn } from 'formik';
import PWAThumbNail from './PWAThumbNail';
import { iconForField } from '../../../common/custom/icon-library';
import { toast } from 'react-toastify';
import { pwaImageTypes, uploadPWAFileOnServer } from '../../../common/utils/fileUploadUtils';

class PWAImageUploadField extends Component {
  checkMimeType = (event) => {
    let files = event.target.files;
    let err = '';

    for (var x = 0; x < files.length; x++) {
      if (pwaImageTypes.every((type) => files[x].type !== type)) {
        err += files[x].type + ' is not a supported format\n';
      }
    }
    if (err !== '') {
      event.target.value = null;
      toast.error(`Failed: ${err}`, {});
      return false;
    }
    return true;
  };

  checkFileSize = (event) => {
    let files = event.target.files;
    let size = 500000;
    let err = '';
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].name + ' is too large, please pick a smaller file upto 500 KB \n';
      }
    }
    if (err !== '') {
      event.target.value = null;
      toast.error(`Failed: ${err}`, {});

      return false;
    }
    return true;
  };

  uploadFile = async (event) => {
    const {
      setFieldValue,
      field,
      folderName,
      projectId,
      version,
      setSubmitting,
      updateEnablePwaConfig,
      plugins,
    } = this.props;
    setSubmitting(true);
    if (this.checkFileSize(event)) {
      if (this.checkMimeType(event)) {
        await uploadPWAFileOnServer(
          event,
          setFieldValue,
          field,
          folderName,
          projectId,
          setSubmitting,
          version,
          plugins,
        );
        updateEnablePwaConfig();
      }
    }
  };

  render() {
    const { field, values, s3Url } = this.props;
    const fieldValue = getIn(values, field.fieldName);
    return (
      <>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-prepend" title={field.fieldTitle['en']}>
              <span className="input-group-text">
                <i className={`wb ${iconForField('file')}`}></i>
                <span className="required">{field.required ? ' *' : ''}</span>
              </span>
            </div>
            <input
              type="file"
              name={field.fieldName}
              className="form-control form-control-sm"
              onChange={this.uploadFile}
              required={field.required}
              accept=".png,.svg,.webp"
            />
            <small className="field-details">
              Allowed square image of dimension: 192x192, maximum size: 500 KB
            </small>
          </div>
        </div>
        <br />
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          <PWAThumbNail file={fieldValue} s3Url={s3Url} />
        </div>
      </>
    );
  }
}

export default PWAImageUploadField;
